import { render, staticRenderFns } from "./UpgradeToGold.vue?vue&type=template&id=725cc31e&"
import script from "./UpgradeToGold.vue?vue&type=script&lang=js&"
export * from "./UpgradeToGold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports